import { Palette, PaletteOptions } from "@mui/material";

const darkPalette: PaletteOptions = {
    mode: 'dark',
    primary: {
        main: '#612aaf',
    },
    text: {
        primary: '#ffffff',
    },
    secondary: {
        main: '#1983e2',
    },
    background: {
        default: '#141A21',
        paper: '#0F1318',
    }
};

export default darkPalette;